import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import './NetworkPhoto.css';

export default class NetworkPhoto extends PureComponent {
  constructor (props) {
    super(props);

    this.state = {
      loading: true,
      isHovering: false,
      imageUri: ''
    };

    this.img = null;
    this._isMounted = false;
  }

  get source () {
    return this.props.source || '';
  }

  componentDidUpdate = (prevProps, prevState) => {
    const { source } = this.props;

    if (source && prevProps.source !== source) {
      this.beginLoadImage();
    }
  }

  componentDidMount = () => {
    this._isMounted = true;
    this.beginLoadImage();
  }

  componentWillUnmount = () => {
    this.img = null;
    this._isMounted = false;
  }

  beginLoadImage = async () => {
    this.skeletonRef && this.skeletonRef.classList.add('skeleton-photo');

    this._isMounted && this.setState({ imageUri: '', loading: true });
    const imageUri = await this.loadImage(this.source);

    this.skeletonRef && this.skeletonRef.classList.remove('skeleton-photo');
    this._isMounted && this.setState({ imageUri, loading: false });
  }

  loadImage = uri => {
    return new Promise((resolve, reject) => {
      const image = new Image();
      this.img = image;

      image.src = uri;
      image.onload = () => resolve(uri);
    });
  }

  render () {
    const { imageUri } = this.state;

    return (
      <div ref={ref => { this.skeletonRef = ref; }} className='skeleton-photo' style={{ height: this.props.height }}>
        <img src={imageUri} className='network-photo' alt='' />
      </div>
    );
  }
}

NetworkPhoto.propTypes = {
  source: PropTypes.string,
  height: PropTypes.number
};
